import React from 'react'
import './dropdownComponent.less'

interface Props {
  children: React.ReactElement
  titleName: string
  isOpened: boolean
  toggleOpening: () => void
}

const DropdownComponent: React.FC<Props> = ({ children, titleName, isOpened = false, toggleOpening }: Props) => {
  return (
    <div className="admin-dropdown-component">
      <div className="dropdown-header" onClick={toggleOpening}>
        {titleName}
        <div className="dropdown-button">
          <span style={{ transform: `rotateX(${isOpened ? '180deg' : '0'})` }}>▾</span>
        </div>
      </div>
      {isOpened && <div className="dropdown-content">{children}</div>}
    </div>
  )
}

export default DropdownComponent
